import {
  applyResolvedTheme,
  readThemePreference,
  resolveTheme,
  systemPrefersLight
} from "./theme.js";

let storage: Pick<Storage, "getItem"> | undefined;
try {
  storage = window.sessionStorage;
} catch {
  // Restricted browsing contexts still receive the system theme.
}

applyResolvedTheme(resolveTheme(readThemePreference(storage), systemPrefersLight()));
